import { useAppTranslation } from 'src/i18n/hooks';
import { notification, Spin } from 'antd';
import React, { useEffect } from 'react';
import { useChainId, useSwitchChain } from 'wagmi';
import { LoadingOutlined } from '@ant-design/icons';
import { useAuth } from 'src/libs/rainbow';
import { useWalletSelector } from '@near-wallet-selector/react-hook';

interface Props {
  children?: React.ReactNode;
  selectedNetwork?: number;
  disabled?: boolean;
}

const Web3ActionButton: React.FC<Props> = ({ children, selectedNetwork }) => {
  const { signedAccountId } = useWalletSelector();
  const { switchChain, isPending, isSuccess, error } = useSwitchChain();
  const { isAuthenticated, signIn, isEthereumWallet } = useAuth();
  const { t } = useAppTranslation(['notifications', 'trade', 'common']);
  const chainId = useChainId();
  const handleConnectWallet = async () => {
    await signIn?.();
  };

  const handleNetworkSwitch = () => {
    if (switchChain && selectedNetwork) {
      switchChain({ chainId: selectedNetwork });
    }
  };

  useEffect(() => {
    if (isSuccess) {
      notification.success({
        message: t('switchChainSuccessMessage'),
        duration: 3,
      });
    }
  }, [isSuccess]);

  useEffect(() => {
    if (error) {
      notification.error({
        message: error.message,
        duration: 3,
      });
    }
  }, [error]);

  if (!signedAccountId || !isAuthenticated) {
    return (
      <button
        type="button"
        className="font-bold bg-gradient-to-tr from-[#0f1fd0] via-[#7110e4] via-[#6f10e4] to-[#c403f6] hover:opacity-[0.9] w-full text-white px-4 py-2 rounded-[10px] mt-4 border-[#494950] border-[1px] disabled:opacity-50 disabled:cursor-not-allowed"
        onClick={handleConnectWallet}
      >
        {t('wallet.connect', { ns: 'common' })}
      </button>
    );
  }

  if (selectedNetwork && chainId !== selectedNetwork) {
    return (
      <button
        type="button"
        className="font-bold bg-gradient-to-tr from-[#0f1fd0] via-[#7110e4] via-[#6f10e4] to-[#c403f6] hover:opacity-[0.9] w-full text-white px-4 py-2 rounded-[10px] mt-4 border-[#494950] border-[1px] disabled:opacity-50 disabled:cursor-not-allowed"
        onClick={handleNetworkSwitch}
      >
        {t('wallet.changeNetwork', { ns: 'common' })}
        {isPending && (
          <Spin
            indicator={
              <LoadingOutlined
                style={{
                  color: 'white',
                }}
                spin
              />
            }
          />
        )}
      </button>
    );
  }

  return <div className="w-full">{children}</div>;
};

export default Web3ActionButton;
